// extracted by mini-css-extract-plugin
export default {"container":"bR-z","leftColumn":"cR-z","rightColumn":"dR-z","item":"eR-z"};